// extracted by mini-css-extract-plugin
export default {"table":"styles_table__ZctZi","button":"styles_button__mV-hI","title":"styles_title__dqY2N"};